import React, { useEffect, useState } from 'react';
import {
  Button,
  Drawer,
  DrawerHeader,
  DrawerFooter,
  DrawerBody,
} from '@one-thd/sui-atomic-components';
import BoxPickers from '@src/components/boxes-dropoff/BoxPickers';
import {
  IReturnShipments,
  setReturnShipments,
  useReturnStore,
} from '@src/stores/returnStore';

interface NumberOfBoxesDrawerProps {
  displayDrawer: boolean;
  closeDrawer: () => void;
}

const NumberOfBoxesDrawer = ({
  displayDrawer,
  closeDrawer,
}: NumberOfBoxesDrawerProps) => {
  const storeShipments = useReturnStore((state) => state.returnShipments) || [];
  const [localShipments, setLocalShipments] =
    useState<IReturnShipments[]>(storeShipments);

  useEffect(() => {
    if (displayDrawer) {
      setLocalShipments(storeShipments || []);
    }
  }, [displayDrawer]);

  const handleSave = () => {
    setReturnShipments(localShipments);
    closeDrawer();
  };

  const handleCancel = () => {
    setLocalShipments(storeShipments); // reset local state
    closeDrawer();
  };

  return (
    <Drawer
      open={displayDrawer}
      onClose={handleCancel}
      position="right"
      className="drawer-z-index-fix"
    >
      <DrawerHeader
        title="Number of boxes to drop off"
        onClose={handleCancel}
      />
      <DrawerBody>
        <BoxPickers
          shipments={localShipments}
          setShipments={setLocalShipments}
        />
      </DrawerBody>
      <DrawerFooter className="sui-bg-primary sui-p-4 sui-relative sui-bottom-0 sui-sticky sui-shadow-sm">
        <div className="sui-flex sui-gap-4 sui-flex-col">
          <Button fullWidth onClick={handleSave}>
            Update Box Number
          </Button>
          <Button fullWidth variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </DrawerFooter>
    </Drawer>
  );
};

export default NumberOfBoxesDrawer;
